<div class="footer">
  <p jhiTranslate="footer">This is your footer</p>
</div>
